var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "fast_preview_mem" }, [
    _c("div", { staticClass: "bd-callout bd-callout-info shadow" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-6 col-xs-12 pr-5" }, [
          _vm.item.pre_text.length > 0
            ? _c(
                "div",
                {
                  staticClass: "row mem_fil border-bottom border-primary pb-3",
                },
                [
                  _c("div", { staticClass: "col-2" }, [_vm._v("Преамбула")]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "col-10",
                    domProps: { innerHTML: _vm._s(_vm.item.pre_text) },
                  }),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.item.problem.length > 0
            ? _c(
                "div",
                {
                  staticClass: "row mem_fil border-bottom border-primary pb-3",
                },
                [
                  _c("div", { staticClass: "col-2" }, [_vm._v("Проблема")]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "col-10",
                    domProps: { innerHTML: _vm._s(_vm.item.problem) },
                  }),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.item.result.length > 0
            ? _c("div", { staticClass: "row mem_fil" }, [
                _c("div", { staticClass: "col-2" }, [
                  _vm._v("Запропоноване рішення"),
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "col-10",
                  domProps: { innerHTML: _vm._s(_vm.item.result) },
                }),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-6 col-xs-12 border-left pl-5 pr-5" }, [
          _vm.item.adjusts.length > 0
            ? _c("div", { staticClass: "adjust_block" }, [
                _c("h4", { staticClass: "card-title" }, [_vm._v("Погодження")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "user_block" },
                  _vm._l(_vm.item.adjusts, function (user) {
                    return _c("user_block", {
                      key: user.user_id,
                      staticClass: "mt-2",
                      attrs: { user: user },
                    })
                  }),
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("h4", { staticClass: "card-title" }, [_vm._v("Видалення")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "user_block" },
            [
              _c("user_block", {
                key: _vm.item.remover.id + "_remover",
                attrs: { user: _vm.item.remover },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }